import { Link } from "react-router-dom";
import { Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import Edit from '../../../modal/hr_management/Manage_Payout/EditPayout';
import React, { useState, useRef, useEffect } from 'react';
import Add from '../../../modal/hr_management/Manage_Payout/AddPayout';
import $ from 'jquery';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const ViewPayout = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const [payoutData, setPayoutData] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [staffList, setStaffList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [TotalCount, setTotalCount] = useState('');
    
    const tableRef = useRef(null);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [selectedPayout, setSelectedPayout] = useState(null);
    const [hasFetched, setHasFetched] = useState(false);
    const [payoutMethodList, setPayoutMethodList] = useState([]);



    const fetchPayouts = () => {
        const params = {
            page,
            per_page: perPage,
            search: searchTerm,
            branch_id: branch_id
        };

        // axios.get(`${baseURL}/managepayouts`, { params })
        //     .then(response => {
        //         const apiData = response.data.data; // expecting object with pagination + data array
        //         setPayoutData(Array.isArray(apiData.data) ? apiData.data : []);
        //         setTotalCount(apiData.total || 0);
        //         setTotalPages(apiData.last_page || 1);
        //         setHasFetched(true);
        //     })
        //     .catch(error => {
        //         console.error('Error fetching payouts:', error);
        //         setHasFetched(true);
        //     });
        axios.get(`${baseURL}/managepayouts`, { params })
            .then(response => {
                const payoutItems = response.data.data;         // payout array
                const pagination = response.data.pagination;    // pagination object

                setPayoutData(Array.isArray(payoutItems) ? payoutItems : []);
                setTotalCount(pagination?.total || 0);
                setTotalPages(pagination?.last_page || 1);
                setHasFetched(true);
            })
            .catch(error => {
                console.error('Error fetching payouts:', error);
                // toast.error('Failed to fetch payouts. Please try again.');
                setHasFetched(true);
            });
    };

    // Use fetchPayouts on mount
    useEffect(() => {
        fetchPayouts();
    }, [page, perPage, searchTerm]);
    
    useEffect(() => {
        axios.get(`${baseURL}/managestaff`)
            .then(response => {
            setStaffList(response.data.data);
            setHasFetched(true);
            })
            .catch(error => {
            console.error('Error fetching staff data', error);
            setHasFetched(true);
            });
    },[] );

    useEffect(() => {
        axios.get(`${baseURL}/paymentmode`) // your payout method API
            .then(response => {
            // console.log("Payout methods fetched:", response.data);
            setPayoutMethodList(response.data || []);
            })
            .catch(err => console.error(err));
    }, []);

    const handleModalToggle = () => {
        setModalType("Add");
        setOpen(true);
    };

    const handleModalToggle_Edit = (payout) => {
        setSelectedPayout(payout);
        setModalType("Edit");
        setOpen(true);
    };

    const generatePayouts = () => {
        const params = {
            branch_id: branch_id,
            user_id: user_id
        };

        axios.post(`${baseURL}/generate_payouts`, params )
            .then(response => {
                toast.success("Payout Generated Successfully!");
                fetchPayouts();
            })
            .catch(error => {
                console.error('Error fetching payouts:', error);
                toast.error("Payout Generation Failed");
                setHasFetched(true);
            });
    };


    // useEffect(() => {
    //     if (hasFetched){
    //     if (tableRef.current) {
    //         if (!$.fn.dataTable.isDataTable(tableRef.current)) {
    //             $(tableRef.current).DataTable({
    //                 "responsive": true,
    //                 "ordering": false,
    //                 "language": {
    //                     "lengthMenu": "Show _MENU_",
    //                 },
    //                 "dom":
    //                     "<'row'" +
    //                     "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
    //                     "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
    //                     ">" +
    //                     "<'table-responsive'tr>" +
    //                     "<'row'" +
    //                     "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
    //                     "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
    //                     ">"
    //             });
    //         }
    //     }}
    // }, [hasFetched]);

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "destroy": true,
                        "paging": false,
                        "searching": false,
                        "info": false,
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched, payoutData]);


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Payout</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Payout Management</li>
                    </ol>
                </div>
                <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={generatePayouts}>
                    <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                    <span className=''>Generate Payout</span>
                </Link>
                {open && modalType === "Add" && (
                    <Add show={open} onClose={() => setOpen(false)} onSuccess={() => { setOpen(false);  fetchPayouts();}}/>
                )}
                {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} payoutData={selectedPayout} onSuccess={() => fetchPayouts()} />
                )}

            </div>
            <div className="table-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>
                <table  id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-50px text-start'>Payout Date / Time</th>
                            {/* <th className='min-w-100px'>Transaction ID</th> */}
                            <th className='min-w-100px'>Staffs</th>
                            <th className='min-w-50px'>Designation</th>
                            <th className='min-w-100px text-center'>Amount</th>
                            <th className='min-w-100px dt-orderable-none dt-type-numeric'>Deductions</th>
                            <th className='min-w-100px text-center'>Net Pay</th>
                            {/* <th className='min-w-100px text-center'>Status</th> */}
                            {/* <th className='min-w-100px text-start'>Payout Method</th> */}
                            {/* <th className='min-w-100px'>Actions</th> */}
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                    {payoutData.map((type, index) => {
                        const payoutDate = new Date(type.payout_date_time);

                        const dateStr = payoutDate.toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                        });

                        const timeStr = payoutDate.toLocaleTimeString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                        });

                        const staff = staffList.find(s => s.sno === type.staff_name);
                        const staffName = staff ? staff.employee_name : 'Unknown';
                        const staffPhone = staff ? staff.phone_no : '';
                        // const payoutMethod = payoutMethodList?.find(pm => pm.sno === type.payout_method);
                        // const payoutMethodName = payoutMethod ? payoutMethod.paymentmode_name : null;
                        const payoutMethod = type.payout_method; 
                        // console.log("Payout method in payoutData:", type.payout_method);
                        const payoutMethodName = payoutMethod ? payoutMethod.paymentmode_name : '';
                        return (
                        <tr key={index}>
                            <td>
                                <label className='text-black font-w400 fs-7'>{dateStr}</label>
                                <div className="d-block">
                                    <label className="fs-8 text-dark">{timeStr}</label>
                                </div>
                            </td>
                            {/* <td>
                                <label className='text-black font-w400 fs-7'>TXN68765</label>
                            </td> */}
                            <td>
                                <label className='text-black font-w400 fs-7'>{staffName}</label>
                                <div className="d-block">
                                    <label className="fs-8 text-dark">{staffPhone}</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w400 fs-7'>{staff?.job_role?.jobrole_name || 'N/A'}</label>
                                <div className="d-block">
                                    <label className="fs-8 text-dark">{staff?.shift_time?.shifttime_name || 'N/A'}</label>
                                </div>
                            </td>
                            <td className="dt-type-numeric">
                                <label className="text-info fw-bold fs-7"><span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span><span>{type.amount}</span></label>
                            </td>
                            <td className="dt-type-numeric">
                                <label className="text-danger fw-bold fs-7"><span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span><span>{type.deductions}</span></label>
                            </td>
                            <td className="dt-type-numeric">
                                <label className="text-primary fw-bold fs-7"><span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span><span>{type.net_pay}</span></label>
                            </td>
                            {/* <td className='text-center'>
                                {type.status === 1 ? (
                                    <span className="text-white fs-7 py-0 px-1 badge bg-success">Paid</span>
                                ) : (
                                    <span className="text-white fs-7 py-0 px-1 badge bg-danger">Pending</span>
                                )}
                            </td>
                            <td className='text-start'>
                                <label className='text-black font-w400 fs-7'> {type.payout_method ? payoutMethodName : '-'}</label>
                            </td> */}
                            {/* <td>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_Edit(type)}>
                                        <span><i class="fa-solid fa-pen-to-square fs-5 mt-1"></i></span>
                                    </Button>
                                </OverlayTrigger>
                            </td> */}
                        </tr>
                        );
                    })}
                    {payoutData.length === 0 && hasFetched && (
                        <tr className="test-center">
                            <td colSpan="9" className="text-center text-muted py-2">
                                No data available
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
                <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {payoutData.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + payoutData.length} of {TotalCount} entries
                            </span>
                        ):(
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>

                </div>
            </div>
        </>
    )
}
export default ViewPayout;